import { useEffect } from 'react';

export function useSwipeRightListener(ref, handler) {
  useEffect(() => {
    const element = document.body;
    let startX, startY, dist, threshold = 150; // required min distance traveled to be considered swipe
    let allowedTime = 300; // maximum time allowed to travel that distance
    let elapsedTime, startTime;
    let isSwiping = false;

    function touchStartHandler(e) {
      const touchobj = e.changedTouches[0];
      dist = 0;
      startX = touchobj.pageX;
      startY = touchobj.pageY;
      startTime = new Date().getTime(); // record time when finger first makes contact with surface
    }

    function touchMoveHandler(e) {
      if (isSwiping) {
        e.preventDefault(); // prevent scrolling when swiping
      }
    }

    function touchEndHandler(e) {
      const touchobj = e.changedTouches[0];
      dist = touchobj.pageX - startX; // get horizontal dist traveled by finger while in contact with surface
      elapsedTime = new Date().getTime() - startTime; // get time elapsed
      // check that elapsed time is within specified, horizontal distance traveled >= threshold, and vertical distance traveled is within 100 pixels
      const swipeRightBol = (elapsedTime <= allowedTime && dist >= threshold && Math.abs(touchobj.pageY - startY) <= 100);
      if (swipeRightBol) {
        isSwiping = true;
        handler(); // call function or perform action on swipe right
        e.preventDefault();
      } else {
        isSwiping = false;
      }
    }

    element.addEventListener('touchstart', touchStartHandler, false);
    element.addEventListener('touchmove', touchMoveHandler, { passive: false });
    element.addEventListener('touchend', touchEndHandler, false);

    return () => {
      element.removeEventListener('touchstart', touchStartHandler);
      element.removeEventListener('touchmove', touchMoveHandler);
      element.removeEventListener('touchend', touchEndHandler);
    };
  }, [handler]); // Re-run effect if handler changes
}